import { IChangeTracking } from "../../../changeTracking/iChangeTracking";

export class RequestAttachments implements IChangeTracking {
    private _current: any;

    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
    }

    get recordNumber(): number {
        return this._current.recordNumber;
    }

    set recordNumber(value: number) {
        this._current.recordNumber = value;
    }


    get attachementName(): string {
        return this._current.attachementName;
    }

    set attachementName(value: string) {
        this._current.attachementName = value;
    }

    get attachmentId(): string {
        return this._current.attachmentId;
    }

    set attachmentId(value: string) {
        this._current.attachmentId = value;
    }

    //private _isAttachmentValid : boolean ;
    //get isAttachmentValid(): boolean {
    //    return this._isAttachmentValid;
    //}

    //set isAttachmentValid(value: boolean) {
    //    this._isAttachmentValid = value;
    //}
    

    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);

    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {

        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestAttachments.ts
 **/